<app-list [divide]="divide()">
  @for (item of items(); track $index) {
  <div
    class="flex py-3 select-none"
    [ngClass]="{
      'flex flex-row items-center space-x-2': item.orientation !== 'vertical',
      '!flex-col space-y-2': item.orientation === 'vertical'
    }"
  >
    @if (item.label) {
    <div class="font-normal">{{ item.label }}:</div>
    } @if (item.isHtml) {
    <div
      [ngClass]="{
        'font-bold': item.bold !== false,
        'font-normal': item.bold === false,
        'pl-4': item.orientation === 'vertical'
      }"
      [appRenderHtml]="item.value?.toString()"
    ></div>
    } @else {
    <div
      [ngClass]="{
        'font-bold': item.bold !== false,
        'font-normal': item.bold === false,
        'pl-4': item.orientation === 'vertical'
      }"
    >
      {{ item.value }}
    </div>
    }
  </div>
  }
</app-list>
